import * as React from 'react';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { NavLink } from 'react-router-dom';
import {ListItem, ListItemButton, ListItemText, useTheme} from '@mui/material';

const useStyles = makeStyles((theme: Theme) => ({
  root: {

  },
  activeLink: {
    borderBottom: `3px solid ${theme.palette.primary.main}`,
  },
  textContainer: {
    color: theme.palette.primary.main,
    textAlign: 'center',
  },
  text: {
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.body2.fontSize,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.75rem',
    },
  },
  listItemGutters: {
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
    [theme.breakpoints.down('xs')]: {
      paddingLeft: theme.spacing(0.25),
      paddingRight: theme.spacing(0.25),
    },
  },
}));

type Props = {
  to: string;
  name: string;
  end?: boolean;
  exact?: boolean;
};

const NavItem: React.FC<Props> = ({ to, name, end = false, exact }: Props) => {

  return (
      <ListItem
          disablePadding
          sx={{
            width: 'auto',
            overflow: 'auto',
            flexGrow: 1,
          }}
      >
        <NavLink
            to={to}
            end={end || exact}
            style={{
              textDecoration: 'none',
              color: 'inherit',
              display: 'flex',
              width: '100%',
            }}
        >
          {({ isActive }) => (
              <ListItemButton
                  sx={(theme) => ({
                    // responsive gutters
                    px: {
                      xs: 0.25,
                      sm: 1,
                    },

                    // active border
                    borderBottom: isActive
                        ? `3px solid ${theme.palette.primary.main}`
                        : '3px solid transparent',
                  })}
              >
                <ListItemText
                    primary={name}
                    primaryTypographyProps={{
                      noWrap: true,
                      sx: (theme) => ({
                        color: theme.palette.primary.main,
                        textAlign: 'center',
                        fontSize: {
                          xs: '0.75rem',
                          sm: theme.typography.body2.fontSize,
                        },
                      }),
                    }}
                />
              </ListItemButton>
          )}
        </NavLink>
      </ListItem>
  );
};

export default NavItem;
